import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { OrderFilter, OrderMarket } from "../types";

export const getOrderListReport = (user: User, filter: OrderFilter) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getorderbookreport",
		params: {
			userid: user.userId,
			secid: filter?.security?.securityId,
			market: OrderMarket.Domestic,
			side: filter?.side,
			status: filter?.orderStatus?.ftValue ,
			dateFrom: getParamsDateString(filter?.dateFrom),
			dateTo: getParamsDateString(filter?.dateTo),
		},
	});
};

export default getOrderListReport;
